import { useCallback, useEffect, useRef, useState } from "react";
import { getOverview } from "./api";
import { errorText } from "../../inquiry/v6Api";

// 기간별 개요를 받는다. 기간을 빠르게 바꿔도 마지막 요청의 응답만 화면에 쓴다.
export default function useOverview(days) {
    const [state, setState] = useState({ data: null, error: null, loading: true });
    const seq = useRef(0);

    const load = useCallback(async () => {
        const my = ++seq.current;
        setState((s) => ({ ...s, loading: true }));
        try {
            const data = await getOverview(days);
            if (my !== seq.current) return null;
            setState({ data, error: null, loading: false });
            return true;
        } catch (e) {
            if (my !== seq.current) return null;
            setState((s) => ({ ...s, error: errorText(e), loading: false }));
            return false;
        }
    }, [days]);

    useEffect(() => {
        load();
        return () => { seq.current += 1; };
    }, [load]);

    return { ...state, reload: load };
}
